/** @format */

import { AddToCartButtonService, selectAtcFulfillmentOption } from '@pdp/add-to-cart/data-access';
import {
	ChangeDetectionStrategy,
	Component,
	ComponentRef,
	TemplateRef,
	effect,
	inject,
	viewChild
} from '@angular/core';
import { DynamicDrawerSizes, ProductSelectionUtilityService } from '@pdp/utils';
import { HmfDrawerComponent, HmfModalFactoryService } from '@dsg-tech/homefield-angular';
import { selectAllProductStyle, selectResolvedSku } from '@pdp/data-access/state';

import { BreakpointsService } from '@shared/data-access/services';
import { ProductAvailabilityNotificationFormComponent } from '../product-availability-notification-form/product-availability-notification-form.component';
import { Store } from '@ngrx/store';
import { selectUserStoreInfo } from '@state/data-access';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'pdp-notify-me-panel',
	templateUrl: './notify-me-panel.component.html',
	styleUrl: './notify-me-panel.component.scss',
	imports: [ProductAvailabilityNotificationFormComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotifyMePanelComponent {
	private readonly store = inject(Store);
	private readonly addToCartButtonService = inject(AddToCartButtonService);
	private readonly pdslUtilityService = inject(ProductSelectionUtilityService);
	private readonly modalFactoryService = inject(HmfModalFactoryService);
	private readonly breakpointsService = inject(BreakpointsService);

	resolvedSku = this.store.selectSignal(selectResolvedSku);

	product = this.store.selectSignal(selectAllProductStyle);

	storeDetails = this.store.selectSignal(selectUserStoreInfo);

	shipMode = this.store.selectSignal(selectAtcFulfillmentOption);

	private drawerRef: ComponentRef<HmfDrawerComponent>;
	drawerContent = viewChild.required<TemplateRef<unknown>>('drawerContent');

	constructor() {
		effect(() => {
			const breakpoint = this.breakpointsService.breakpoint();
			if (this.drawerRef) {
				this.drawerRef.setInput(
					'size',
					this.pdslUtilityService.getValueByScreenSize(DynamicDrawerSizes, breakpoint)
				);
			}
		});

		this.addToCartButtonService.openNotifyMePanel$
			.pipe(takeUntilDestroyed())
			.subscribe((shouldOpen: boolean) => {
				if (shouldOpen) {
					this.openDrawer();
				}
			});
	}

	openDrawer() {
		if (!this.drawerRef) {
			this.drawerRef = this.modalFactoryService.create(
				HmfDrawerComponent,
				{
					headerText: 'Notify Me When Available',
					closable: true,
					mobilePeek: true,
					direction: 'right',
					isCloseButtonSticky: true,
					size: this.pdslUtilityService.getValueByScreenSize(
						DynamicDrawerSizes,
						this.breakpointsService.breakpoint()
					)
				},
				this.drawerContent()
			);
		}

		this.drawerRef.instance.openDrawer();
	}

	closeDrawer() {
		this.drawerRef.instance.closeDrawer();
	}
}
